/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2026.
 *
 * Public DibotChat entry point.
 *
 * The widget is loaded with `next/dynamic({ ssr: false })` for two reasons:
 *  1. Correctness: the Microsoft Omnichannel SDK touches `window` and
 *     `localStorage` at construction time. Without ssr:false, Next.js will
 *     crash at SSR time with "window is not defined".
 *  2. Performance: ~150 KB of SDK code is moved into a client-only chunk
 *     that is only fetched after the page is interactive.
 */
import dynamic from 'next/dynamic';

const DibotChat = dynamic(() => import('./DibotChat').then((m) => m.DibotChat), { ssr: false });

export default DibotChat;
